import React from 'react';
import {useTheme} from 'styled-components';
import {useTranslation} from 'react-i18next';
import {useFetchIVLottie, useModalControls, usePath} from '../../../hooks';
import {ButtonProps} from '../../../components/common/Button/Button';
import {PATHS} from '../../../Routes';
import ModalSheet from '../../../components/common/ModalSheet';
import StandardModalSheet from '../../../components/common/StandardModalSheet';
import {
  Wrapper,
  AutoFillSubTitle,
  AutoFillText,
  AutoFillTitle,
  IconWrapper,
  StyledArrowIcon,
  StyledIcon,
} from './styled';

export function AutoFill() {
  const {t} = useTranslation();
  const {
    isOpen: isOpenConfirmAutoFillModal,
    openModal: openConfirmAutoFillModal,
    closeModal: closeConfirmAutoFillModal,
  } = useModalControls();
  const theme = useTheme();
  const {getFullPath} = usePath();
  const {animationData: ocrAnimationLottie} = useFetchIVLottie({isOrc: true});

  const modalSheetButtons: ButtonProps[] = React.useMemo(
    () => [
      {
        primary: true,
        label: t('scan_your_document'),
        to: getFullPath(PATHS.documentMRZ),
      },
      {
        link: true,
        label: t('complete_the_form_manually'),
        onClick: closeConfirmAutoFillModal,
      },
    ],
    [t, closeConfirmAutoFillModal, getFullPath],
  );

  return (
    <Wrapper onClick={openConfirmAutoFillModal} className="auto-fill-card">
      <AutoFillText>
        <AutoFillTitle className="auto-fill-card__title">
          <StyledIcon name={'thunder'} color={theme.colors.branding.primary} />
          <span>{t('auto_fill_form')}</span>
        </AutoFillTitle>
        <AutoFillSubTitle className="auto-fill-card__subtitle">
          {t('save_time_scanning')}
        </AutoFillSubTitle>
      </AutoFillText>
      <IconWrapper className="auto-fill-card__arrow">
        <StyledArrowIcon name={'arrowRightBlue'} />
      </IconWrapper>
      <ModalSheet
        isOpenModalSheet={isOpenConfirmAutoFillModal}
        handleCloseModal={closeConfirmAutoFillModal}
        title={t('do_you_want_auto_fill_form')}
        withCloseButton
        closeButtonType="click"
        pressToTheTop
      >
        <StandardModalSheet
          buttons={modalSheetButtons}
          text={t('auto_fill_form_modal_text')}
          lottie={ocrAnimationLottie}
        />
      </ModalSheet>
    </Wrapper>
  );
}
